import React from 'react';
import PropTypes from 'prop-types'
import style from './slider.less';
import FormComponent from '../FormComponent.jsx';
import { KEY_CODES, compareObjectsInclusive, compareObjects } from '../../../common/utils.jsx';
import classNames from 'classnames';

const { ARROW_LEFT, ARROW_RIGHT } = KEY_CODES;

export default class Slider extends FormComponent {
    constructor() {
        super();
        this.moveHandle = this.moveHandle.bind(this);
        this.addMouseMoveListener = this.addMouseMoveListener.bind(this);
        this.removeMouseMoveListener = this.removeMouseMoveListener.bind(this);
        this.convertInternalToReal = this.convertInternalToReal.bind(this);
        this.submitValue = this.submitValue.bind(this);
        this.getSliderWidth = this.getSliderWidth.bind(this);
        this.keyDownHandler = this.keyDownHandler.bind(this);
        this.state = {
            internalValue: 0,
            transactionStarted: false
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return compareObjectsInclusive(this.props, nextProps, [ 'value', 'min', 'max', 'name', 'error', 'disabled' ])
            || compareObjects(this.state, nextState);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value && 0 === nextProps.value) {
            this.setState({ internalValue: 0 });
        }
    }
    componentDidMount() {
        this.refs.slider.addEventListener('mousedown', this.addMouseMoveListener);
        this.refs.slider.addEventListener('touchstart', this.addMouseMoveListener);
    }
    componentWillUnmount() {
        this.refs.slider.removeEventListener('mousedown', this.addMouseMoveListener);
        this.refs.slider.removeEventListener('touchstart', this.addMouseMoveListener);
        this.refs.slider.removeEventListener('mouseup', this.removeMouseMoveListener);
        this.refs.slider.removeEventListener('touchend', this.removeMouseMoveListener);
    }
    addMouseMoveListener() {
        this.refs.slider.addEventListener('click', this.moveHandle);
        document.addEventListener('mousemove', this.moveHandle);
        document.addEventListener('touchmove', this.moveHandle);
        document.addEventListener('mouseup', this.removeMouseMoveListener);
        document.addEventListener('touchend', this.removeMouseMoveListener);
        this.setState({ transactionStarted: true });
    }
    getSliderWidth() {
        /* Fallback for unit tests which can not get clientWidth value without DOM */
        const isRenderedSlider = this.refs.slider && this.refs.slider.clientWidth;
        return isRenderedSlider ? this.refs.slider.clientWidth : 325;
    }
    convertInternalToReal(internalValue) {
        const { max, min } = this.props;
        return Math.round(internalValue * ((max - min) / this.getSliderWidth()) + min);
    }
    convertRealToInternal(value) {
        const { max, min } = this.props;
        return Math.round((value - min) / ((max - min) / this.getSliderWidth()));
    }
    submitValue() {
        const value = this.convertInternalToReal(this.state.internalValue);
        this.onChangeHandler(value);
    }
    moveHandle(event) {
        if (this.props.disabled) { return; }
        const eventType = event.type;
        const left = this.refs.slider.getBoundingClientRect().left;
        const offset = eventType.includes('touch') ? event.targetTouches[0].pageX - left : event.pageX - left;
        const SLIDER_WIDTH = this.getSliderWidth();
        if (SLIDER_WIDTH <= offset) {
            this.setState({ internalValue:  SLIDER_WIDTH });
        } else if (0 >= offset) {
            this.setState({ internalValue:  0 });
        } else {
            this.setState({ internalValue:  offset });
        }
        if ('click' === event.type) { this.submitValue(); }
        this.props.sliderMoveCallback(this.convertInternalToReal(this.state.internalValue));
    }
    removeMouseMoveListener() {
        document.removeEventListener('mousemove', this.moveHandle);
        document.removeEventListener('touchmove', this.moveHandle);
        document.removeEventListener('mouseup', this.removeMouseMoveListener);
        document.removeEventListener('touchend', this.removeMouseMoveListener);
        this.setState({ transactionStarted: false });
        this.submitValue();
    }
    keyDownHandler(event) {
        const keyCode = event.keyCode;
        const { max, min, value } = this.props;
        const step = Math.ceil((max - min) / 50);
        let updatedValue = null;
        if (ARROW_LEFT === keyCode) {
            updatedValue = min < (value - step) ? value - step : min;
        } else if (ARROW_RIGHT === keyCode) {
            updatedValue = max > (value + step) ? value + step : max;
            updatedValue = min > updatedValue ? updatedValue + min : updatedValue;
        }
        if (null !== updatedValue) {
            this.setState({ internalValue: this.convertRealToInternal(updatedValue) });
            this.onChangeHandler(updatedValue);
        }
    }
    render() {
        const { name, value, error, disabled } = this.props;
        const { transactionStarted, internalValue } = this.state;
        let sliderValue;
        if (value && !error && (!transactionStarted || !internalValue)) {
            sliderValue = this.convertRealToInternal(value);
        } else {
            sliderValue = internalValue;
        }
        const selectionWidth = { width: sliderValue };
        const handlePosition = { left: sliderValue };
        const tabIndex = disabled ? -1 : 0;
        const cssTrackClass = classNames(style.track, { [style.disabled]: disabled });
        return (
            <div className={style.wrapper} ref="slider">
                <input disabled={disabled} type="hidden" name={name} value={this.convertInternalToReal(sliderValue)}/>
                <div className={cssTrackClass} ref="track">
                    <div className={style.selection} style={selectionWidth}></div>
                    <div className={style.handle} style={handlePosition} ref="handle" tabIndex={tabIndex} onKeyDown={this.keyDownHandler}></div>
                </div>
            </div>
        );
    }
}
Slider.propTypes = {
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
};
Slider.defaultProps = {
    min: 0,
    max: 100
};


